// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2F815","author":"Table_author__2WQIt","authorImage":"Table_authorImage__2_ZYz","unreadRow":"Table_unreadRow__8wBCB"};